import styled from 'styled-components';
import { defaultTheme } from 'constants/theme/defaultTheme';

export const Styles = {
  Footer: styled.div`
    width: 100%;
    background: rgba(33, 35, 64, 1)
      radial-gradient(
        133.73% 98.18% at 100% 0%,
        rgba(0, 158, 255, 0.25) 0%,
        rgba(33, 35, 64, 0.25) 100%
      );
    position: fixed;
    padding: ${defaultTheme.spacing(4)};
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 2;
  `,
  Content: styled.div`
    max-width: ${({ theme }) => theme.maxContentWidth}px;
    margin: 0 auto;
    display: flex;
    flex-direction: row;
    height: 100%;
    align-items: center;
    justify-content: space-between;
  `,
  LeftHandSide: styled.div`
    display: flex;
    align-items: center;
    padding-right: ${defaultTheme.spacing(4)};
    flex-grow: 1;
  `,
  RightHandSide: styled.div`
    width: 100%;
    flex-basis: 280px;
    flex-grow: 0;
    margin-left: ${defaultTheme.spacing(4)};
  `,
  CompanyDetails: styled.div`
    margin-left: ${defaultTheme.spacing(4)};
  `,
  Logo: styled.div`
    flex-shrink: 0;
  `,

  Icon: styled.div`
    width: 40px;
    height: 40px;
  `,
};
